import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from '../../theme';
import { Checkbox as HeadlessCheckbox } from '@headlessui/react';
import { useCheckboxStyles } from './Checkbox.Styles';
import { CheckBoxIcon, IndeterminateCheckIcon } from '../../icons';
export const Checkbox = ({ className, styled = true, ...props }) => {
    const theme = useTheme();
    const styles = useCheckboxStyles({
        ...{},
        theme
    });
    return (_jsx(HeadlessCheckbox, { className: `${className} ${styled ? styles.checkbox : undefined}`, ...props, children: props.indeterminate ? (_jsx(IndeterminateCheckIcon, {})) : props.checked ? (_jsx(CheckBoxIcon, { className: styles.checkboxIcon })) : null }));
};
